module.exports = __webpack_public_path__ + "static/media/Bluelab Combo Meter.80ed4c66.webp";